import { ActionType, createAsyncAction } from "typesafe-actions";

import { EntityTypesSupportingRoutes, Route } from "@mapmycustomers/shared/types/entity";
import { RoutePreview } from "@mapmycustomers/shared/types/entity/Route";

import { RoutePreviewPayload } from "../api/ApiService";

export const fetchCompanyRoutes = createAsyncAction(
  "@routes/fetchCompanyRoutes/request",
  "@routes/fetchCompanyRoutes/success",
  "@routes/fetchCompanyRoutes/failure"
)<
  {
    query?: string;
    // these are routes which must be included into result, e.g. because user selected them
    selectedRouteIds?: Route["id"][];
  },
  Route[],
  void
>();

export const fetchPeopleRoutes = createAsyncAction(
  "@routes/fetchPeopleRoutes/request",
  "@routes/fetchPeopleRoutes/success",
  "@routes/fetchPeopleRoutes/failure"
)<
  {
    query?: string;
    // these are routes which must be included into result, e.g. because user selected them
    selectedRouteIds?: Route["id"][];
  },
  Route[],
  void
>();

export const fetchRoute = createAsyncAction(
  "@routes/fetchRoute/request",
  "@routes/fetchRoute/success",
  "@routes/fetchRoute/failure"
)<
  {
    callback: (route: Route) => void;
    entityType: EntityTypesSupportingRoutes;
    id: Route["id"];
  },
  void,
  void
>();

export const fetchRoutePreview = createAsyncAction(
  "@routes/fetchRoutePreview/request",
  "@routes/fetchRoutePreview/success",
  "@routes/fetchRoutePreview/failure"
)<
  {
    callback?: (route: RoutePreview) => void;
    entityType: EntityTypesSupportingRoutes;
    payload: RoutePreviewPayload;
  },
  void,
  void
>();

export type Actions = ActionType<
  | typeof fetchCompanyRoutes
  | typeof fetchPeopleRoutes
  | typeof fetchRoute
  | typeof fetchRoutePreview
>;
